import { Controller, useFormContext } from 'react-hook-form';

import { InputField } from '@nesso/ui/primitives/input-field';

import { type CreateClientInput, MAX_INPUT_FIELD_LENGTH } from '@/entities/client';
import { FieldReveal } from '@/shared/ui/forms/field-reveal';

export function QuickAddClientNameFields() {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<CreateClientInput>();

    return (
        <>
            <Controller
                control={control}
                name="firstName"
                render={({ field, fieldState }) => (
                    <InputField
                        {...field}
                        id={field.name}
                        label="Legal first name"
                        disabled={isSubmitting}
                        maxLength={MAX_INPUT_FIELD_LENGTH}
                        error={fieldState.error?.message ?? fieldState.invalid}
                    />
                )}
            />
            <Controller
                control={control}
                name="lastName"
                render={({ field, fieldState }) => (
                    <InputField
                        {...field}
                        id={field.name}
                        label="Legal last name"
                        disabled={isSubmitting}
                        maxLength={MAX_INPUT_FIELD_LENGTH}
                        error={fieldState.error?.message ?? fieldState.invalid}
                    />
                )}
            />
            <FieldReveal
                label="Add preferred first name"
                disabled={isSubmitting}
                triggerClassName="mb-6"
            >
                <Controller
                    control={control}
                    name="preferredFirstName"
                    render={({ field, fieldState }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            label="Preferred first name (optional)"
                            disabled={isSubmitting}
                            maxLength={MAX_INPUT_FIELD_LENGTH}
                            error={fieldState.error?.message ?? fieldState.invalid}
                        />
                    )}
                />
            </FieldReveal>
        </>
    );
}
